import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_STUDENT_ASSIGNMENTS_STATE } from "./consts";
import StudentAssignment, {
  defaultStudentAssignmentValues,
  StudentAssignmentType
} from "./models/StudentAssignment";
import studentAssignmentsReducer from "./reducers/state";
import * as studentAssignmentSelectors from "./selectors/state/assignments/assignment/studentAssignment";

ReducerRegistry.getInstance().initialise(
  PATH_TO_STUDENT_ASSIGNMENTS_STATE,
  builder => {
    builder.register(
      PATH_TO_STUDENT_ASSIGNMENTS_STATE,
      studentAssignmentsReducer
    );
    import("../analytics");
  }
);

//reducer
// actions
export {
  deleteAssignments,
  receiveAssignmentsWithContents,
  receiveAssignmentWithContents,
  updateAssignmentSectionStat
} from "./actions";
export {
  fetchAllStudentAssignmentsActionFactory,
  fetchChildAssignmentActionFactory,
  fetchChildAssignmentsActionFactory,
  fetchCurrentStudentAssignmentsActionFactory,
  fetchStudentAssignmentActionFactory
} from "./actions/meta";
export { default as StudentAssignmentsState } from "./models/StudentAssignmentsState";
// selectors
export {
  assignmentExists,
  assignmentIncludesExamQuestions,
  getAllAssignmentIds,
  getAllAssignments,
  getAssignment,
  getAssignmentClassId,
  getAssignmentContentIds,
  getAssignmentContentIdsForSection,
  getAssignmentCourseId,
  getAssignmentCutoffDate,
  getAssignmentDueDate,
  getAssignmentExamQuestionIds,
  getAssignmentExamQuestionMark,
  getAssignmentExamQuestionMarksTotal,
  getAssignmentExamQuestionStat,
  getAssignmentName,
  getAssignmentNumberOfSections,
  getAssignmentProgress,
  getAssignmentQuizBestMarks,
  getAssignmentQuizIds,
  getAssignmentQuizMarksTotal,
  getAssignmentSectionBestScore,
  getAssignmentSectionIds,
  getAssignmentSpecType,
  getAssignmentStartDate,
  getAssignmentStatus,
  getAssignmentStudiedSectionsAverageBestScore,
  getAssignmentTotalStudyTime,
  getAssignmentWordIds,
  getHasStartedAssignment,
  getNumberOfItemsAssigned,
  getNumberOfItemsStudied,
  getNumberOfSectionsCompleted,
  getNumberOfSessionsAssigned,
  getNumberOfSessionsStudied,
  getNumberOfUnstudiedItems,
  getNumberOfUpcomingAssignments,
  getStudiedSectionContents,
  getStudiedSectionIds,
  hasMoreThanOneAssignment,
  isAssignmentExamQuestionFlagged,
  isAssignmentQuizzesOnly,
  isLastQuizToFinishAssignment,
  isLastSectionToFinishAssignment,
  makeCourseHasFutureAsssignments,
  makeGetAssignmentAggregatedQuestionsMarks,
  makeGetAssignmentsForUser,
  makeGetClassAssignmentIds,
  makeGetFutureAssignmentIdsForCourse,
  makeGetFutureAssignments,
  makeGetFutureAssignmentsForCourse,
  makeGetNextDueAssignmentForCourse,
  makeGetNextDueAssignmentId,
  makeGetNextDueAssignmentIdForSection,
  makeGetNextDueAssignmentIdForSectionOrCourse,
  makeIsAssignmentAfterCutoffDate,
  makeIsFutureAssignmentStartDate,
  questionHasBeenStudied,
  quizHasBeenStudied,
  sectionContentHasBeenStudied,
  sectionHasBeenStudied
} from "./selectors";
// meta selectors
export {
  allStudentAssignmentsAreFetching,
  allStudentAssignmentsFetchErrored,
  allStudentAssignmentsFetchFinished,
  allStudentAssignmentsFetchSucceeded,
  allStudentAssignmentsNeedFetching,
  childAssignmentFetchErrored,
  childAssignmentFetchFinished,
  childAssignmentFetchSucceeded,
  childAssignmentIsFetching,
  childAssignmentNeedsFetching,
  childAssignmentsAreFetching,
  childAssignmentsFetchErrored,
  childAssignmentsFetchFinished,
  childAssignmentsFetchSucceeded,
  childAssignmentsNeedFetching,
  // fetch all student assignments
  currentStudentAssignmentsAreFetching,
  currentStudentAssignmentsFetchErrored,
  currentStudentAssignmentsFetchFinished,
  currentStudentAssignmentsFetchSucceeded,
  currentStudentAssignmentsNeedFetching,
  studentAssignmentFetchErrored,
  studentAssignmentFetchFinished,
  studentAssignmentFetchSucceeded,
  studentAssignmentIsFetching,
  studentAssignmentNeedsFetching
} from "./selectors/meta";
export { studentAssignmentsReducer };
// models
export {
  defaultStudentAssignmentValues,
  StudentAssignment,
  studentAssignmentSelectors
};
export type { StudentAssignmentType };
// consts
export { PATH_TO_STUDENT_ASSIGNMENTS_STATE };
